var _path, _rect, _circle, _g, _rect2, _rect3, _rect4, _path2, _path3, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTips2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 431,
    height: 399,
    viewBox: "0 0 431 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H404C418.912 0 431 12.0883 431 27V372C431 386.912 418.912 399 404 399H52C37.6406 399 26 387.359 26 373V0Z",
    fill: "#FFF5F5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 283.05,
    width: 92,
    height: 87,
    rx: 11,
    transform: "rotate(-44.9964 0 283.05)",
    fill: "#FFEBEB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 302,
    cy: 79,
    r: 35,
    fill: "#FFEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3028)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 94,
    width: 333,
    height: 202,
    rx: 9,
    fill: "#EBF9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 190.25H268C271.728 190.25 274.75 193.272 274.75 197V295.75H62.25V197C62.25 193.272 65.2721 190.25 69 190.25Z",
    fill: "#F5FEFF",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.25,
    y: 206.25,
    width: 212.5,
    height: 20.5,
    rx: 2.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 216,
    r: 7,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 213,
    width: 6,
    height: 6,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 211,
    width: 55,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 211,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 211,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 211,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 213,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 216,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 219,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.25,
    y: 227.25,
    width: 212.5,
    height: 20.5,
    rx: 2.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 237,
    r: 7,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 234,
    width: 6,
    height: 6,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 232,
    width: 55,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 232,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 232,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 232,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 234,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 237,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 240,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.25,
    y: 248.25,
    width: 212.5,
    height: 20.5,
    rx: 2.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 258,
    r: 7,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 255,
    width: 6,
    height: 6,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 253,
    width: 55,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 253,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 253,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 253,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 255,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 258,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 261,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.25,
    y: 269.25,
    width: 212.5,
    height: 20.5,
    rx: 2.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 279,
    r: 7,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 276,
    width: 6,
    height: 6,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 274,
    width: 55,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 274,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 274,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 274,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 276,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 279,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 282,
    r: 1,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.25,
    y: 290.25,
    width: 212.5,
    height: 20.5,
    rx: 2.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 300,
    r: 7,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 295,
    width: 55,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 295,
    width: 8,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 295,
    width: 30,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 295,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.25,
    y: 121.25,
    width: 75.5,
    height: 43.5,
    rx: 4.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.25,
    y: 121.25,
    width: 128.5,
    height: 43.5,
    rx: 4.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.25,
    y: 121.25,
    width: 128.5,
    height: 173.5,
    rx: 4.75,
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 179,
    width: 16,
    height: 4,
    rx: 1,
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 179,
    width: 16,
    height: 4,
    rx: 1,
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.25,
    y: 171.25,
    width: 35.5,
    height: 15.5,
    rx: 4.75,
    fill: "white",
    stroke: "#FC563A",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.845 176.483V178.679H242.004V179.453H238.845V182H237.945V175.7H242.391V176.483H238.845ZM243.444 177.23H244.308V182H243.444V177.23ZM243.876 176.312C243.708 176.312 243.567 176.258 243.453 176.15C243.345 176.042 243.291 175.91 243.291 175.754C243.291 175.598 243.345 175.466 243.453 175.358C243.567 175.244 243.708 175.187 243.876 175.187C244.044 175.187 244.182 175.241 244.29 175.349C244.404 175.451 244.461 175.58 244.461 175.736C244.461 175.898 244.404 176.036 244.29 176.15C244.182 176.258 244.044 176.312 243.876 176.312ZM245.958 175.322H246.822V182H245.958V175.322ZM251.268 181.721C251.142 181.829 250.986 181.913 250.8 181.973C250.614 182.027 250.422 182.054 250.224 182.054C249.744 182.054 249.372 181.925 249.108 181.667C248.844 181.409 248.712 181.04 248.712 180.56V177.941H247.902V177.23H248.712V176.186H249.576V177.23H250.944V177.941H249.576V180.524C249.576 180.782 249.639 180.98 249.765 181.118C249.897 181.256 250.083 181.325 250.323 181.325C250.587 181.325 250.812 181.25 250.998 181.1L251.268 181.721ZM256.465 179.642C256.465 179.708 256.459 179.795 256.447 179.903H252.577C252.631 180.323 252.814 180.662 253.126 180.92C253.444 181.172 253.837 181.298 254.305 181.298C254.875 181.298 255.334 181.106 255.682 180.722L256.159 181.28C255.943 181.532 255.673 181.724 255.349 181.856C255.031 181.988 254.674 182.054 254.278 182.054C253.774 182.054 253.327 181.952 252.937 181.748C252.547 181.538 252.244 181.247 252.028 180.875C251.818 180.503 251.713 180.083 251.713 179.615C251.713 179.153 251.815 178.736 252.019 178.364C252.229 177.992 252.514 177.704 252.874 177.5C253.24 177.29 253.651 177.185 254.107 177.185C254.563 177.185 254.968 177.29 255.322 177.5C255.682 177.704 255.961 177.992 256.159 178.364C256.363 178.736 256.465 179.162 256.465 179.642ZM254.107 177.914C253.693 177.914 253.345 178.04 253.063 178.292C252.787 178.544 252.625 178.874 252.577 179.282H255.637C255.589 178.88 255.424 178.553 255.142 178.301C254.866 178.043 254.521 177.914 254.107 177.914ZM258.493 178.031C258.643 177.755 258.865 177.545 259.159 177.401C259.453 177.257 259.81 177.185 260.23 177.185V178.022C260.182 178.016 260.116 178.013 260.032 178.013C259.564 178.013 259.195 178.154 258.925 178.436C258.661 178.712 258.529 179.108 258.529 179.624V182H257.665V177.23H258.493V178.031ZM262.698 182.054C262.308 182.054 261.933 182.003 261.573 181.901C261.213 181.793 260.931 181.658 260.727 181.496L261.087 180.812C261.297 180.962 261.552 181.082 261.852 181.172C262.152 181.262 262.455 181.307 262.761 181.307C263.517 181.307 263.895 181.091 263.895 180.659C263.895 180.515 263.844 180.401 263.742 180.317C263.64 180.233 263.511 180.173 263.355 180.137C263.205 180.095 262.989 180.05 262.707 180.002C262.323 179.942 262.008 179.873 261.762 179.795C261.522 179.717 261.315 179.585 261.141 179.399C260.967 179.213 260.88 178.952 260.88 178.616C260.88 178.184 261.06 177.839 261.42 177.581C261.78 177.317 262.263 177.185 262.869 177.185C263.187 177.185 263.505 177.224 263.823 177.302C264.141 177.38 264.402 177.485 264.606 177.617L264.237 178.301C263.847 178.049 263.388 177.923 262.86 177.923C262.494 177.923 262.215 177.983 262.023 178.103C261.831 178.223 261.735 178.382 261.735 178.58C261.735 178.736 261.789 178.859 261.897 178.949C262.005 179.039 262.137 179.105 262.293 179.147C262.455 179.189 262.68 179.237 262.968 179.291C263.352 179.357 263.661 179.429 263.895 179.507C264.135 179.579 264.339 179.705 264.507 179.885C264.675 180.065 264.759 180.317 264.759 180.641C264.759 181.073 264.573 181.418 264.201 181.676C263.835 181.928 263.334 182.054 262.698 182.054Z",
    fill: "#FC563A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.949 164.684C265.865 164.433 265.685 164.224 265.447 164.106C265.21 163.987 264.936 163.967 264.684 164.051C264.432 164.135 264.224 164.315 264.105 164.553C263.987 164.79 263.967 165.065 264.051 165.316L265.051 168.316C265.135 168.568 265.315 168.776 265.552 168.895C265.79 169.013 266.064 169.033 266.316 168.949C266.568 168.865 266.776 168.685 266.894 168.448C267.013 168.211 267.033 167.936 266.949 167.684L265.949 164.684ZM272.707 167.707C272.889 167.519 272.99 167.266 272.988 167.004C272.985 166.742 272.88 166.491 272.695 166.305C272.509 166.12 272.258 166.015 271.996 166.013C271.734 166.01 271.481 166.111 271.293 166.293L269.293 168.293C269.111 168.482 269.01 168.734 269.012 168.997C269.014 169.259 269.12 169.51 269.305 169.695C269.49 169.88 269.741 169.986 270.003 169.988C270.266 169.99 270.518 169.889 270.707 169.707L272.707 167.707ZM260.317 169.051C260.065 168.967 259.79 168.987 259.553 169.105C259.316 169.224 259.135 169.432 259.051 169.684C258.967 169.935 258.987 170.21 259.106 170.447C259.224 170.685 259.432 170.865 259.684 170.949L262.684 171.949C262.936 172.033 263.21 172.013 263.447 171.895C263.685 171.776 263.865 171.568 263.949 171.316C264.033 171.065 264.013 170.79 263.894 170.553C263.776 170.315 263.568 170.135 263.316 170.051L260.317 169.051ZM267.342 171.061C267.163 170.996 266.97 170.984 266.784 171.025C266.598 171.066 266.428 171.159 266.294 171.293C266.159 171.428 266.066 171.598 266.024 171.783C265.983 171.969 265.995 172.162 266.06 172.341L270.06 183.341C270.129 183.532 270.255 183.696 270.419 183.814C270.584 183.931 270.781 183.996 270.984 183.999C271.186 184.002 271.385 183.944 271.553 183.832C271.722 183.72 271.853 183.559 271.928 183.371L273.365 179.78L277.293 183.707C277.385 183.803 277.495 183.879 277.617 183.931C277.739 183.984 277.871 184.011 278.003 184.012C278.136 184.014 278.268 183.988 278.391 183.938C278.514 183.888 278.625 183.814 278.719 183.72C278.813 183.626 278.887 183.514 278.938 183.391C278.988 183.268 279.013 183.137 279.012 183.004C279.011 182.871 278.983 182.74 278.931 182.618C278.879 182.496 278.802 182.385 278.707 182.293L274.779 178.365L278.371 176.929C278.559 176.854 278.72 176.723 278.833 176.555C278.945 176.386 279.003 176.187 279 175.984C278.997 175.782 278.932 175.585 278.814 175.42C278.697 175.255 278.532 175.129 278.341 175.06L267.341 171.06L267.342 171.061ZM264.707 175.707C264.802 175.615 264.879 175.505 264.931 175.383C264.983 175.261 265.011 175.129 265.012 174.997C265.013 174.864 264.988 174.732 264.938 174.609C264.887 174.486 264.813 174.375 264.719 174.281C264.625 174.187 264.514 174.113 264.391 174.062C264.268 174.012 264.136 173.987 264.003 173.988C263.871 173.989 263.739 174.017 263.617 174.069C263.495 174.122 263.385 174.198 263.293 174.293L261.293 176.293C261.197 176.385 261.121 176.496 261.069 176.618C261.016 176.74 260.989 176.871 260.988 177.004C260.986 177.137 261.012 177.268 261.062 177.391C261.112 177.514 261.187 177.626 261.28 177.72C261.374 177.814 261.486 177.888 261.609 177.938C261.732 177.988 261.864 178.014 261.996 178.012C262.129 178.011 262.26 177.984 262.382 177.931C262.504 177.879 262.615 177.803 262.707 177.707L264.707 175.707Z",
    fill: "#FC563A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 128,
    width: 22,
    height: 5,
    rx: 2.5,
    fill: "#FFB2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 128,
    width: 22,
    height: 5,
    rx: 2.5,
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 128,
    width: 22,
    height: 5,
    rx: 2.5,
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.25,
    y: 176.25,
    width: 35.5,
    height: 9.5,
    rx: 4.75,
    fill: "white",
    stroke: "#DCDCDC",
    strokeWidth: 0.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51.25,
    y: 94.25,
    width: 332.5,
    height: 201.5,
    rx: 8.75,
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 293.25,
    y: 144.25,
    width: 103.5,
    height: 50.5,
    rx: 4.75,
    fill: "#FEFDFD",
    stroke: "#DCDCDC",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 177,
    width: 29,
    height: 14,
    rx: 5,
    fill: "#FC563A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M304.857 184.775H302.253L301.714 186H300.993L303.212 181.1H303.905L306.131 186H305.396L304.857 184.775ZM304.612 184.215L303.555 181.814L302.498 184.215H304.612ZM308.731 182.255C309.09 182.255 309.412 182.334 309.697 182.493C309.982 182.652 310.203 182.873 310.362 183.158C310.525 183.443 310.607 183.772 310.607 184.145C310.607 184.518 310.525 184.85 310.362 185.139C310.203 185.424 309.982 185.645 309.697 185.804C309.412 185.963 309.09 186.042 308.731 186.042C308.465 186.042 308.22 185.991 307.996 185.888C307.777 185.785 307.59 185.636 307.436 185.44V187.358H306.764V182.29H307.408V182.878C307.557 182.673 307.746 182.519 307.975 182.416C308.204 182.309 308.456 182.255 308.731 182.255ZM308.675 185.454C308.913 185.454 309.125 185.4 309.312 185.293C309.503 185.181 309.653 185.027 309.76 184.831C309.872 184.63 309.928 184.402 309.928 184.145C309.928 183.888 309.872 183.662 309.76 183.466C309.653 183.265 309.503 183.111 309.312 183.004C309.125 182.897 308.913 182.843 308.675 182.843C308.442 182.843 308.229 182.899 308.038 183.011C307.851 183.118 307.702 183.27 307.59 183.466C307.483 183.662 307.429 183.888 307.429 184.145C307.429 184.402 307.483 184.63 307.59 184.831C307.697 185.027 307.847 185.181 308.038 185.293C308.229 185.4 308.442 185.454 308.675 185.454ZM313.502 182.255C313.862 182.255 314.184 182.334 314.468 182.493C314.753 182.652 314.975 182.873 315.133 183.158C315.297 183.443 315.378 183.772 315.378 184.145C315.378 184.518 315.297 184.85 315.133 185.139C314.975 185.424 314.753 185.645 314.468 185.804C314.184 185.963 313.862 186.042 313.502 186.042C313.236 186.042 312.991 185.991 312.767 185.888C312.548 185.785 312.361 185.636 312.207 185.44V187.358H311.535V182.29H312.179V182.878C312.329 182.673 312.518 182.519 312.746 182.416C312.975 182.309 313.227 182.255 313.502 182.255ZM313.446 185.454C313.684 185.454 313.897 185.4 314.083 185.293C314.275 185.181 314.424 185.027 314.531 184.831C314.643 184.63 314.699 184.402 314.699 184.145C314.699 183.888 314.643 183.662 314.531 183.466C314.424 183.265 314.275 183.111 314.083 183.004C313.897 182.897 313.684 182.843 313.446 182.843C313.213 182.843 313.001 182.899 312.809 183.011C312.623 183.118 312.473 183.27 312.361 183.466C312.254 183.662 312.2 183.888 312.2 184.145C312.2 184.402 312.254 184.63 312.361 184.831C312.469 185.027 312.618 185.181 312.809 185.293C313.001 185.4 313.213 185.454 313.446 185.454ZM316.307 180.806H316.979V186H316.307V180.806ZM321.545 182.29L319.746 186.371C319.587 186.749 319.401 187.015 319.186 187.169C318.976 187.323 318.722 187.4 318.423 187.4C318.241 187.4 318.064 187.37 317.891 187.309C317.723 187.253 317.583 187.169 317.471 187.057L317.758 186.553C317.949 186.735 318.171 186.826 318.423 186.826C318.586 186.826 318.722 186.782 318.829 186.693C318.941 186.609 319.041 186.462 319.13 186.252L319.249 185.993L317.611 182.29H318.311L319.606 185.258L320.887 182.29H321.545Z",
    fill: "#FEFDFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94.25H375C379.832 94.25 383.75 98.1675 383.75 103V113.75H51.25V103C51.25 98.1675 55.1675 94.25 60 94.25Z",
    fill: "white",
    stroke: "#C6D5DD",
    strokeWidth: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 75,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 75,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 75,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 91,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 91,
    width: 54,
    height: 13,
    rx: 6,
    fill: "#FFEBEB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 151,
    width: 29,
    height: 8,
    rx: 1,
    fill: "#E2E2E2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 163,
    width: 29,
    height: 8,
    rx: 1,
    fill: "#E2E2E2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 331,
    y: 151,
    width: 28,
    height: 8,
    rx: 1,
    fill: "#E2E2E2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 331,
    y: 163,
    width: 28,
    height: 8,
    rx: 1,
    fill: "#E2E2E2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 151,
    width: 29,
    height: 8,
    rx: 1,
    fill: "#E2E2E2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 163,
    width: 29,
    height: 8,
    rx: 1,
    fill: "#E2E2E2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3028"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 94,
    width: 333,
    height: 202,
    rx: 9,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips2);
export default __webpack_public_path__ + "static/media/tips2.ad4efa84d787abfc672588a7bcec16e1.svg";
export { ForwardRef as ReactComponent };